import { fontsVkSans } from "@/utils/load_fonts/fonts/vk_sans";

import { fontsAvenyt } from "./avenyt";
import { IFont } from "./fonts.types";
import { fontsLobster } from "./lobster";
import { fontsMarckScript } from "./marck_script";
import { fontsOpenSans } from "./open_sans";
import { fontsOswald } from "./oswald";
import { fontsPacifico } from "./pacifico";
import { fontsPtSerif } from "./pt_serif";
import { fontsRoboto } from "./roboto";
import { fontsTgico } from "./tgico";
import { fontsTgicoV2 } from "./tgico_v2";

export const fontsList: Record<string, IFont[]> = {
  AvenyT: fontsAvenyt,
  Lobster: fontsLobster,
  "Marck Script": fontsMarckScript,
  "Open Sans": fontsOpenSans,
  Oswald: fontsOswald,
  "PT Serif": fontsPtSerif,
  Pacifico: fontsPacifico,
  Roboto: fontsRoboto,
  "VK Sans Display": fontsVkSans,
  tgico: fontsTgico,
  tgico_v2: fontsTgicoV2,
};
